// @ts-nocheck
/**
 * Favorites (Wishlist) — Shopify storefront client
 * Source of truth: Lovable Supabase favorites edge function.
 * Config is injected by snippets/favorites-config.liquid on window.AvidFavoritesConfig.
 * (Plain JS served by Shopify CDN — TS checker disabled.)
 */
(function () {
  'use strict';

  var cfg = window.AvidFavoritesConfig;
  if (!cfg || !cfg.apiUrl) {
    console.warn('[Favorites] Config missing, aborting init.');
    return;
  }

  // Inject PDP-specific styles so product-title can render a flex row
  // with the heart icon beside it. Kept in JS so Shopify's theme-check
  // linter cannot strip inline <style> tags from Liquid files.
  (function injectFavoritesStyles() {
    if (document.getElementById('favorites-pdp-styles')) return;
    var style = document.createElement('style');
    style.id = 'favorites-pdp-styles';
    style.textContent = [
      '.product-title-with-favorite {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: space-between;',
      '  gap: 12px;',
      '  width: 100%;',
      '}',
      '.product-title-with-favorite .favorites-heart {',
      '  position: static;',
      '  top: auto;',
      '  right: auto;',
      '  width: 40px;',
      '  height: 40px;',
      '  background: transparent;',
      '  backdrop-filter: none;',
      '  -webkit-backdrop-filter: none;',
      '  flex: 0 0 auto;',
      '}',
      '.product-title-with-favorite .favorites-heart:hover {',
      '  background: rgba(0, 0, 0, 0.05);',
      '  transform: scale(1.1);',
      '}',
      '.product-title-with-favorite .favorites-heart__icon {',
      '  width: 22px;',
      '  height: 22px;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  })();

  var state = {
    ids: new Set(),
    loaded: false,
    inFlight: new Set(), // product_ids currently being toggled
  };

  function buildHeaders() {
    return {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + cfg.bearerToken,
    };
  }

  function apiGet() {
    var url = cfg.apiUrl + '?user_id=' + encodeURIComponent(cfg.shopifyUserId);
    return fetch(url, { method: 'GET', headers: buildHeaders() })
      .then(handleResponse);
  }

  function apiMutate(action, productId) {
    return fetch(cfg.apiUrl + '/' + action, {
      method: 'POST',
      headers: buildHeaders(),
      body: JSON.stringify({
        user_id: String(cfg.shopifyUserId),
        product_id: String(productId),
      }),
    }).then(handleResponse);
  }

  function handleResponse(res) {
    return res.json().then(function (data) {
      if (!res.ok) {
        var err = new Error(data && data.error ? data.error : 'Request failed');
        err.status = res.status;
        throw err;
      }
      return data;
    });
  }

  function isFavorite(productId) {
    return state.ids.has(String(productId));
  }

  function paintAll() {
    var buttons = document.querySelectorAll('[data-favorite-button]');
    for (var i = 0; i < buttons.length; i++) {
      paintOne(buttons[i]);
    }
  }

  function paintOne(btn) {
    var pid = btn.getAttribute('data-product-id');
    if (!pid) return;
    var fav = isFavorite(pid);
    btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
    btn.classList.toggle('is-favorite', fav);
    btn.setAttribute(
      'aria-label',
      fav ? 'Remove from favorites' : 'Add to favorites'
    );
  }

  function toggle(productId, btn) {
    var pid = String(productId);

    if (!cfg.isLoggedIn) {
      window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }

    if (state.inFlight.has(pid)) return; // debounce rapid clicks
    state.inFlight.add(pid);

    var wasFavorite = isFavorite(pid);
    // Optimistic update
    if (wasFavorite) {
      state.ids.delete(pid);
    } else {
      state.ids.add(pid);
    }
    if (btn) paintOne(btn);

    var action = wasFavorite ? 'remove' : 'add';
    apiMutate(action, pid)
      .then(function (data) {
        // Reconcile with authoritative server list
        state.ids = new Set((data.favoriteProductIds || []).map(String));
        paintAll();
        broadcast();

      })
      .catch(function (err) {
        console.error('[Favorites] toggle failed:', err);
        // Revert optimistic update
        if (wasFavorite) {
          state.ids.add(pid);
        } else {
          state.ids.delete(pid);
        }
        if (btn) paintOne(btn);
      })
      .finally(function () {
        state.inFlight.delete(pid);
      });
  }

  function bindClicks() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-favorite-button]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      var pid = btn.getAttribute('data-product-id');
      if (pid) toggle(pid, btn);
    });
  }

  function init() {
    bindClicks();

    if (!cfg.isLoggedIn || !cfg.shopifyUserId) {
      // Guest: render hearts in unfavorited state; clicks route to login.
      paintAll();
      return;
    }

    apiGet()
      .then(function (data) {
        state.ids = new Set((data.favoriteProductIds || []).map(String));
        state.loaded = true;
        paintAll();
        broadcast();

      })
      .catch(function (err) {
        console.warn('[Favorites] initial load failed:', err);
        paintAll();
      });
  }

  // Expose for dynamic sections (product grid reloads, AJAX'd content).
  window.AvidFavorites = {
    isFavorite: isFavorite,
    toggle: toggle,
    refresh: paintAll,
      getIds: function () { return Array.from(state.ids); },
    getCount: function () { return state.ids.size; },
    isLoaded: function () { return state.loaded; },
  };

  // Notify listeners after favorites finish loading / mutating.
  function broadcast() {
    document.dispatchEvent(new CustomEvent('avid-favorites:updated', {
      detail: { count: state.ids.size, ids: Array.from(state.ids) }
    }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-paint after Shopify section renders (theme editor + pagination).
  document.addEventListener('shopify:section:load', paintAll);
})();
